var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_2147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71571 23.2843 0 15 0C6.71571 0 0 6.71571 0 15C0 23.2843 6.71571 30 15 30Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10089 5.86743C1.92263 7.40043 1.03417 9.16732 0.516846 11.0868H8.32025L3.10089 5.86743Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4835 11.087C28.9662 9.16757 28.0776 7.40068 26.8994 5.86768L21.6802 11.087H29.4835Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.516846 18.913C1.03423 20.8324 1.92269 22.5993 3.10089 24.1322L8.32009 18.913H0.516846Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1325 3.1007C22.5995 1.92244 20.8327 1.03399 18.9132 0.516602V8.31995L24.1325 3.1007Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86768 26.8991C7.40068 28.0774 9.16757 28.9659 11.087 29.4833V21.6799L5.86768 26.8991Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0869 0.516602C9.16751 1.03399 7.40062 1.92244 5.86768 3.10064L11.0869 8.31989V0.516602Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9132 29.4833C20.8326 28.9659 22.5995 28.0774 24.1325 26.8992L18.9132 21.6799V29.4833Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6802 18.913L26.8994 24.1323C28.0776 22.5993 28.9662 20.8324 29.4835 18.913H21.6802Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.873 13.0435H16.9566H16.9566V0.126973C16.3161 0.0435937 15.6631 0 15 0C14.3368 0 13.6839 0.0435937 13.0435 0.126973V13.0434V13.0434H0.126973C0.0435937 13.6839 0 14.3369 0 15C0 15.6632 0.0435937 16.3161 0.126973 16.9565H13.0434H13.0434V29.873C13.6839 29.9564 14.3368 30 15 30C15.6631 30 16.3161 29.9564 16.9565 29.873V16.9566V16.9566H29.873C29.9564 16.3161 30 15.6632 30 15C30 14.3369 29.9564 13.6839 29.873 13.0435Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9132 18.913L25.6067 25.6066C25.9146 25.2988 26.2082 24.9771 26.4884 24.6436L20.7578 18.913H18.9132V18.913Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.087 18.9132H11.0869L4.39343 25.6066C4.70117 25.9145 5.02291 26.2082 5.35642 26.4884L11.087 20.7577V18.9132Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0867 11.0871V11.087L4.39319 4.39343C4.08534 4.70117 3.79167 5.02291 3.51147 5.35642L9.24212 11.0871H11.0867V11.0871Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9132 11.087L25.6068 4.39338C25.299 4.08553 24.9773 3.79185 24.6438 3.51172L18.9132 9.24237V11.087Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_2147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/UnitedKingdom.27b3d6e8c6757bfdd99dadc36dc553c9.svg";
export { ForwardRef as ReactComponent };